// eslint-disable-next-line sonarjs/cognitive-complexity
;(function () {
  'use strict'

  function focusFirstRevealedHeading(truncatableItems, fromIndex) {
    for (let index = fromIndex; index < truncatableItems.length; index++) {
      const item = truncatableItems[index]
      const heading = item.matches('h3') ? item : item.querySelector('h3')
      if (heading) {
        heading.setAttribute('tabindex', '-1')
        heading.focus()
        return
      }
    }

    // No new heading was revealed (truncation cut off mid-category) - focus the
    // first newly revealed cell instead, so screen reader users still land on the new content.
    const firstRevealedItem = truncatableItems[fromIndex]
    const focusTarget = firstRevealedItem?.querySelector('th, td') || firstRevealedItem
    if (focusTarget) {
      focusTarget.setAttribute('tabindex', '-1')
      focusTarget.focus()
    }
  }

  function onDocumentReady() {
    const productInformationList = document?.querySelector('.cmp-product-information-table')
    const toggleButton = document?.querySelector('.cmp-product-information__cta-button')
    if (!productInformationList || !toggleButton) {
      return
    }

    // Flattened in document order so items nested inside per-category <table> elements
    // are still counted individually, the same way top-level siblings were counted before.
    const truncatableItems = productInformationList.querySelectorAll('.cmp-product-information-table__truncate-item')
    const itemsCountThreshold = 6
    const maxVisibleItems = 5

    if (truncatableItems.length <= itemsCountThreshold) {
      toggleButton.hidden = true
      return
    }

    for (const [index, item] of truncatableItems.entries()) {
      if (index >= maxVisibleItems) {
        item.hidden = true
      }
    }

    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true'
      toggleButton.setAttribute('aria-expanded', String(!isExpanded))

      if (isExpanded) {
        for (const [index, item] of truncatableItems.entries()) {
          if (index >= maxVisibleItems) {
            item.hidden = true
          }
        }
        toggleButton.textContent = toggleButton.dataset.showMoreLabel
        document?.querySelector('.cmp-product-information')?.scrollIntoView({ behavior: 'smooth' })
      } else {
        for (const item of truncatableItems) {
          item.hidden = false
        }
        toggleButton.textContent = toggleButton.dataset.showLessLabel
        focusFirstRevealedHeading(truncatableItems, maxVisibleItems)
      }
    })
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
